/* eslint-disable react/no-unescaped-entities */
"use client";

import React, { useState, useRef, useEffect } from "react";

import Heading from "@/components/heading/heading";
import Button from "@/components/button/Button";

import Image from "next/image";

import "@/sections/common/tariff/tariff.scss";
import { getImageUrl } from "@/utils/imageUrl";

const Tariff = () => {
    const [showSecondContainer, setShowSecondContainer] = useState(false);
    const secondContainerRef = useRef<HTMLDivElement | null>(null);

    const handleViewMore = () => {
        setShowSecondContainer(true);
    };

    const handleViewLess = () => {
        setShowSecondContainer(false);

        const familyPackagesElement = document.getElementById("tariffsection");
        if (familyPackagesElement) {
            familyPackagesElement.scrollIntoView({ behavior: "smooth" });
        }
    };

    useEffect(() => {
        if (secondContainerRef.current) {
            if (showSecondContainer) {
                // Set max-height to the actual height of the content for smooth transition
                const contentHeight = secondContainerRef.current.scrollHeight;
                secondContainerRef.current.style.maxHeight = `${contentHeight}px`;
            } else {
                secondContainerRef.current.style.maxHeight = "0";
            }
        }
    }, [showSecondContainer]);

    return (
        <section className="tariff-section pt-6" id="tariffsection">
            <div className="container px-4 mx-auto">
                <div className="tariff-wrapper flex flex-col gap-6 p-3 md:p-6">
                    {/* <div className="tariff-head pb-3">
                        <Heading as="h2">
                            Explore the Magic of Azerbaijan: Tour Packages from
                            India
                        </Heading>
                    </div> */}
                    <div className="tariff-body-footer flex flex-col gap-4">
                        <div className="tariff-body flex flex-col gap-4 px-3 md:px-6">
                            <p className="lead">
                                Nestled at the crossroads of Eastern Europe and
                                Western Asia, Azerbaijan, the "Land of Fire,"
                                beckons Indian travellers with its captivating
                                blend of ancient history, vibrant culture,
                                modern marvels, and breathtaking natural beauty.

                            {!showSecondContainer && (
                                <span
                                    className="font-medium view-more ml-4 cursor-pointer text-blue-600 hover:text-blue-800"
                                    onClick={handleViewMore}
                                >
                                    View More
                                </span>
                            )}
                            </p>

                            <div
                                id="second-container"
                                ref={secondContainerRef}
                                className={`transition-all duration-500 overflow-hidden  flex flex-col gap-4 ${
                                    showSecondContainer
                                        ? "max-h-full opacity-100"
                                        : "max-h-0 opacity-0"
                                }`}
                            >
                                <p className="lead">
                                From Baku’s cutting-edge cityscape to the
                                peaceful mountain landscapes of Gabala and the
                                rich historical allure of Sheki, Azerbaijan
                                delivers a truly unmatched and diverse travel
                                adventure.
                            </p>
                            
                                <p className="lead">
                                    If you're seeking an extraordinary adventure
                                    that's both accessible and truly memorable,
                                    our Azerbaijan tour packages from India are
                                    designed just for you.
                                </p>

                                <Heading as="h3">
                                    Top Reasons To Choose Our Azerbaijan Tour
                                    Packages From India
                                </Heading>
                                <ul className="list-inside ml-4">
                                    <li>Hassle-free visa assistance</li>
                                    <li>Indian-friendly food options</li>
                                    <li>
                                        Customisable itineraries (budget to
                                        luxury)
                                    </li>
                                    <li>
                                        Private transfers and guided sightseeing
                                    </li>
                                    <li>
                                        Handpicked hotels across Baku, Gabala,
                                        and Sheki
                                    </li>
                                </ul>

                                <p className="lead">
                                    Our Azerbaijan tourism packages from India
                                    are designed for every kind of traveller —
                                    couples, families, solo explorers, or
                                    groups. Whether you're into architecture,
                                    adventure, culture, or nature, our packages
                                    ensure you experience the best of Azerbaijan
                                    without the stress of planning.
                                </p>

                                <Heading as="h3">
                                    Azerbaijan Trip Cost From India - What To
                                    Expect
                                </Heading>
                                <p className="lead">
                                    The Azerbaijan trip cost from India can vary
                                    depending on the duration of your stay,
                                    accommodation type, activities, and travel
                                    season. It remains one of the most
                                    affordable international destinations for
                                    Indian travellers.
                                </p>

                                <Heading as="h4">
                                    Here's A General Breakdown To Give You An
                                    Idea
                                </Heading>
                                <ul className="list-inside ml-4">
                                    <li>
                                        <strong>Flights:</strong> ₹25,000 -
                                        ₹50,000 (round-trip)
                                    </li>
                                    <li>
                                        <strong>Accommodation:</strong>
                                        <ul className="list-disc list-inside ml-6">
                                            <li>
                                                Budget (Hostels): ₹1,000 -
                                                ₹2,000 / night
                                            </li>
                                            <li>
                                                Mid-Range (3–4 Star): ₹3,500 -
                                                ₹6,000 / night
                                            </li>
                                            <li>
                                                Luxury (5-Star): ₹10,000+ /
                                                night
                                            </li>
                                        </ul>
                                    </li>
                                    <li>
                                        <strong>Meals:</strong> ₹500 - ₹3,000 /
                                        day (for 2 people)
                                    </li>
                                    <li>
                                        <strong>Local Transport:</strong> ₹30 -
                                        ₹800 / ride
                                    </li>
                                    <li>
                                        <strong>Attraction Entry:</strong> ₹500
                                        - ₹1,500 each
                                    </li>
                                    <li>
                                        <strong>Visa:</strong> ₹3,000 (e-Visa)
                                    </li>
                                </ul>

                                <p className="lead font-semibold">
                                    Estimated Total Cost for a 5–7 Day Trip:
                                </p>
                                <ul className="list-inside ml-4">
                                    <li>
                                        <strong>Budget Trip:</strong> ₹40,000 -
                                        ₹60,000 / person
                                    </li>
                                    <li>
                                        <strong>Mid-Range:</strong> ₹70,000 -
                                        ₹1,00,000 / person
                                    </li>
                                    <li>
                                        <strong>Luxury:</strong> ₹1,20,000+ /
                                        person
                                    </li>
                                </ul>

                                <Heading as="h3">
                                    Handpicked Tour Itineraries: Something For
                                    Every Traveller
                                </Heading>
                                <ul className="list-inside ml-4">
                                    <li>
                                        <strong>
                                            3 Nights / 4 Days – ₹29,999/Person*
                                        </strong>
                                        <br />- Baku city tour, Flame Towers,
                                        Old City, Fire Temple, Departure
                                    </li>
                                    <li>
                                        <strong>
                                            4 Nights / 5 Days – ₹45,999/Person*
                                        </strong>
                                        <br />- Baku full-day tour, Gobustan +
                                        Mud Volcanoes, Shahdag Resort
                                    </li>
                                    <li>
                                        <strong>
                                            6 Nights / 7 Days – ₹61,999/Person*
                                        </strong>
                                        <br />- Baku, Gabala, Sheki, Shahdag
                                        adventure + shopping
                                    </li>
                                </ul>

                                <p className="lead font-semibold">
                                    Want More Options?
                                </p>
                                <ul className="list-inside ml-4">
                                    <li>
                                        5N Classic Azerbaijan Tour – ₹53,999
                                        (Baku + Shahdag)
                                    </li>
                                    <li>
                                        7N Luxury Escape – ₹68,999 (Baku,
                                        Gabala, Sheki)
                                    </li>
                                    <li>
                                        Azerbaijan Express Tour – ₹49,999 (Baku
                                        + Gabala)
                                    </li>
                                </ul>

                                <Heading as="h3">
                                    What’s Included in Your Azerbaijan Travel
                                    Deal?
                                </Heading>
                                <ul className="list-inside ml-4">
                                    <li>Return Airfare (optional)</li>
                                    <li>Hotels with breakfast</li>
                                    <li>Visa assistance</li>
                                    <li>Airport & city transfers</li>
                                    <li>English-speaking guides</li>
                                    <li>Entry fees to main attractions</li>
                                    <li>24x7 support</li>
                                </ul>

                                <Heading as="h3">
                                    Can’t-Miss Destinations In Azerbaijan
                                </Heading>

                                <Heading as="h4">Baku</Heading>
                                <ul className="list-inside ml-4">
                                    <li>
                                        Old City (Icherisheher), Maiden Tower
                                    </li>
                                    <li>Flame Towers, Heydar Aliyev Center</li>
                                    <li>Fountains Square, Baku Boulevard</li>
                                    <li>Carpet Museum</li>
                                </ul>

                                <Heading as="h4">Gabala</Heading>
                                <ul className="list-inside ml-4">
                                    <li>Nohur Lake, Yeddi Gozel Waterfalls</li>
                                    <li>Tufandag Cable Car & Ski Resort</li>
                                </ul>

                                <Heading as="h4">Sheki</Heading>
                                <ul className="list-inside ml-4">
                                    <li>Sheki Khans Palace, Kish Church</li>
                                    <li>Sheki Caravanserai</li>
                                </ul>

                                <Heading as="h4">Absheron Peninsula</Heading>
                                <ul className="list-inside ml-4">
                                    <li>Ateshgah (Fire Temple)</li>
                                    <li>Yanar Dag (Burning Mountain)</li>
                                </ul>

                                <Heading as="h4">
                                    Gobustan National Park
                                </Heading>
                                <p className="lead ml-1">
                                    Petroglyphs and mud volcanoes – part of most
                                    Baku itineraries.
                                </p>

                                <Heading as="h3">
                                    Visa Made Simple: Your Gateway to Azerbaijan
                                </Heading>
                                <ul className="list-inside ml-4">
                                    <li>Apply on ASAN e-Visa portal</li>
                                    <li>
                                        Standard in 3 days | Express in 3 hours
                                    </li>
                                    <li>
                                        Requirements: Passport scan, photo,
                                        basic info
                                    </li>
                                    <li>
                                        Valid for 30 days within 90-day window
                                    </li>
                                </ul>

                                <Heading as="h3">
                                    When Is The Best Time To Visit Azerbaijan?
                                </Heading>
                                <ul className="list-inside ml-4">
                                    <li>
                                        <strong>Spring (Apr–Jun):</strong> Ideal
                                        weather & Novruz Festival
                                    </li>
                                    <li>
                                        <strong>Autumn (Sep–Oct):</strong> Cool,
                                        fewer crowds
                                    </li>
                                    <li>
                                        <strong>Summer (Jul–Aug):</strong> Great
                                        for Gabala, Sheki & Caspian coast
                                    </li>
                                    <li>
                                        <strong>Winter (Nov–Mar):</strong> Ski
                                        resorts & festive vibes
                                    </li>
                                </ul>

                                <Heading as="h3">
                                    Book Now, Your Azerbaijan Journey Awaits
                                </Heading>
                                <p className="lead">
                                    The Land of Fire awaits your discovery. With
                                    history, scenery, and warm hospitality,
                                    Azerbaijan is an unforgettable destination.
                                </p>
                                <p className="lead font-semibold">
                                    Talk to our travel experts and get your
                                    personalised Azerbaijan package from India
                                    today.
                                </p>
                            </div>
                        </div>
                    </div>
                    {showSecondContainer && (
                        <div className="traffic-footer flex-wrap flex items-center justify-evenly gap-3 md:gap-5 pt-4">
                            <div>
                                <a
                                    target="_blank"
                                    href="https://api.whatsapp.com/send/?phone=919600099777&text=Hi%2C+I+am+Seeking+More+Details+on+Azerbaijan+Tour+Packages.&type=phone_number&app_absent=0"
                                >
                                    <Button
                                        className="flex items-center gap-3"
                                        variant="green"
                                    >
                                        <Image
                                            src={getImageUrl("/svg/common/social-icons/whatsapp.svg")}
                                            alt="whatsapp"
                                            width={24}
                                            height={24}
                                        />
                                        <span>Get Quote</span>
                                    </Button>
                                </a>
                            </div>
                            <div
                                className="flex items-center gap-3 cursor-pointer"
                                onClick={handleViewLess}
                            >
                                <span className="text-link">View Less</span>
                                <Image src={getImageUrl("/svg/line-arrow-right.svg")} alt="right icon" width={20} height={20}/>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

export default Tariff;
